let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cJhLC")).then(() => parcelRequire('4m2RD'));